<div class="input-container">
    <nz-input-group [nzSuffix]="keyword ? keywordClearTpl : keywordSearch"
        [ngClass]="isFullSize?'full-width':'select-style'">
        <input
            type="text"
            nz-input
            (input)="input()"
            [(ngModel)]="keyword"
            [placeholder]="placeholder"
            (keydown)="enterSearch($event)"
            (ngModelChange)="changeKeyword()"
        />
    </nz-input-group>
    <ng-template #keywordSearch>
        <em nz-icon nzType="search" (click)="handleRefresh()" *ngIf="!keyword"></em>
    </ng-template>
    <ng-template #keywordClearTpl>
        <em
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="keyword"
            (click)="clearKeyword()"
        ></em>
    </ng-template>

</div>
